import { Component, inject, Input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TextInputComponent } from "@app/kernel/form/modules/inputs/simple-inputs/components/text-input/text-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { ProfileFormModel } from "../../models/profile-form.model";
import { RouterModule } from "@angular/router";
import { ButtonComponent } from "@app/kernel/shared/modules/button/components/button/button.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-profile-form",
  imports: [TranslateModule, TextInputComponent, ReactiveFormsModule, RouterModule, ButtonComponent, CommonModule],
  templateUrl: "./profile-form.component.html",
  styleUrls: ["./profile-form.component.scss"],
})
export class ProfileFormComponent {
  @Input() onResetPassword!: () => void;
  @Input() onDeleteAccount!: () => void;
  @Input() onUpdateEmail!: () => void;
  @Input() saveProfileChanges!: () => void;
  readonly formModel = inject(ProfileFormModel);
}
